import * as ruleNames from './ruleNames'

export const textTypes: {
  readonly [key: string]: string
} = {
  [ruleNames.ALPHA_NUM]: '半角英数字',
  [ruleNames.INTEGER]: '数字',
  [ruleNames.EMAIL]: 'メールアドレス',
  [ruleNames.URL]: 'URL',
  [ruleNames.HIRAGANA]: '平仮名'
}
